import { render, staticRenderFns } from "./OperatingCurrenciesTable.vue?vue&type=template&id=a79d9996&scoped=true"
import script from "./OperatingCurrenciesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OperatingCurrenciesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OperatingCurrenciesTable.vue?vue&type=style&index=0&id=a79d9996&prod&scoped=true&lang=css"
import style1 from "./OperatingCurrenciesTable.vue?vue&type=style&index=1&id=a79d9996&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79d9996",
  null
  
)

export default component.exports